import google from 'google-maps';

export default {
  init() {
    var $status = $('.pagingInfo');
      var $slickElement = $('.stats-slider');

      $slickElement.on(
        'init reInit afterChange',
        function (event, slick, currentSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)

          var i = (currentSlide ? currentSlide : 0) + 1;
          $status.text(i + '/' + slick.slideCount);
        }
      );

      // Intro Slider
      $('.stats-slider').slick({
        // autoplay: true,
        dots: false,
        adaptiveHeight: true,
        appendArrows: $('.arrows'),
        responsive: [
          {
            breakpoint: 480,
            settings: {
              dots: false,
              arrows: true,
              draggable: true,
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      google.charts.load('current', { packages: ['bar', 'corechart'] });
      google.charts.setOnLoadCallback(drawChart);

      function drawChart() {
        var data = google.visualization.arrayToDataTable([
          ['Year', 'Homeless Veterans', { type: 'string', role: 'style' }],
          [
            '2005',
            11185,
            'point { size: 8; shape-type: circle; fill-color: #a52714; }',
          ],
          ['2007', 6007, null],
          ['2009', 4981, null],
          [
            '2011',
            6281,
            'point { size: 8; shape-type: circle; fill-color: #a52714; }',
          ],
          ['2013', 4007, null],
          [
            '2015',
            4016,
            'point { size: 8; shape-type: circle; fill-color: #a52714; }',
          ],
          ['2016', 2728, null],
          [
            '2017',
            4800,
            'point { size: 8; shape-type: circle; fill-color: #a52714; }',
          ],
        ]);

        var options = {
          hAxis: {
            title: 'Year',
            titleTextStyle: {
              color: '#333',
            },
          },
          stroke: '#a72736',
          lineWidth: 3,
          pointSize: 1,
          dataOpacity: 1,
          legend: 'none',
          series: {
            0: { color: '#a72736' },
          },
          vAxis: { minValue: 0 },
        };

        // Chart 2
        var data_2 = new google.visualization.arrayToDataTable([
          ['Year', 'Sheltered', 'Unsheltered'],
          ['2016', 1453, 1618],
          ['2017', 1289, 3539],
        ]);

        var options_2 = {
          // width: 800,
          chart: {
            //title: 'Total Homeless Veteran Population',
            // subtitle: 'Los Angeles County, 2016 - 2017'
          },
          bars: 'vertical', // Required for Material Bar Charts.
        };

        // Chart 3
        var data_3 = google.visualization.arrayToDataTable([
          [
            'Year',
            'Veteran Housing Placements, Los Angeles County',
            { type: 'string', role: 'style' },
          ],
          [
            '2014',
            3769,
            'point { size: 8; shape-type: circle; fill-color: #a52714; }',
          ],
          [
            '2016',
            3584,
            'point { size: 8; shape-type: circle; fill-color: #a52714; }',
          ],
        ]);

        var options_3 = {
          hAxis: {
            title: 'Year',
            titleTextStyle: {
              color: '#333',
            },
          },
          stroke: '#a72736',
          lineWidth: 3,
          pointSize: 1,
          dataOpacity: 1,
          legend: 'none',
          series: {
            0: { color: '#a72736' },
          },
          vAxis: { minValue: 0 },
        };

        var chart = new google.visualization.AreaChart(
          document.getElementById('chart_div')
        );
        var chart_2 = new google.charts.Bar(
          document.getElementById('chart_div_2')
        );
        var chart_3 = new google.visualization.AreaChart(
          document.getElementById('chart_div_3')
        );
        chart.draw(data, options);
        chart_2.draw(data_2, options_2);
        chart_3.draw(data_3, options_3);
      }
  },
  finalize() {
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/data.js